

const initialState = {
    cards: [],
    currentStep: 1, 
    selectedCardId: null,
    currentMdmEntity: null,
    formConfig:[]
  };
  
  const cardReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case "updateCards":
        return {
          ...state,
          cards: action.payload,
        };
      case "setMdmCurrentStep":
        return {
          ...state,
          currentStep: action.payload,
        };
      case "setSelectedCardId": 
      return {
        ...state,
        selectedCardId: action.payload,
      };
      case "setMdmCurrentEntity": 
      return {
        ...state,
        currentMdmEntity: action.payload,
      };
      case "setFormConfig":
      return {
        ...state,
        formConfig: action.payload,
      };
      default:
        return state;
    }
  };
  
  export default cardReducer;
  